export enum ReportType {
  TASK = 'ORDER',
  FREE = 'FREE',
}

export const ReportTitles: Record<ReportType, string> = {
  [ReportType.TASK]: 'Мониторинг выполнения наряда фельдшера',
  [ReportType.FREE]: 'Сводный отчет',
};
